import { render, staticRenderFns } from "./EmployeeUnverifiedTable.vue?vue&type=template&id=070f7ada&scoped=true&"
import script from "./EmployeeUnverifiedTable.vue?vue&type=script&lang=js&"
export * from "./EmployeeUnverifiedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070f7ada",
  null
  
)

export default component.exports